var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-modal',{ref:"message",staticClass:"v-message invoked",on:{"close":function($event){return _vm.$emit('close',$event)}}},[_c('div',{directives:[{name:"scrollbar",rawName:"v-scrollbar"}],staticClass:"message"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }